

export default function SupportingForm({ formData, handleInputChange,errors }) {
    const handleChange = (e) => {
        handleInputChange(e); // Call the parent function which already handles validation
    };

    const documentOptions = [
        { id: "identity", label: "Proof of identity (e.g., driver's license, passport)" },
        { id: "address", label: "Proof of address (e.g., utility bill, rental agreement)" },
        { id: "income", label: "Proof of income (e.g., pay stubs, tax returns)" },
        { id: "credit", label: "Credit report (if available)" },
    ];

    return (
        <div>
            <h4>Supporting Documents</h4>
            <div className="single-box pt_15 mb-1">
                <div className="inner-title">
                    <p>Please provide copies of the following documents:</p>
                    <ul className="list-style-form">
                        {documentOptions.map((item) => (
                            <li key={item.id}>
                                <input
                                    type="checkbox"
                                    name={item.id}
                                    id={item.id}
                                    checked={formData[item.id] || false}
                                    onChange={handleChange}
                                />
                                <label htmlFor={item.id}>{item.label}</label>
                                {errors[item.id] && <span className="error-message">{errors[item.id]}</span>} {/*  Fixed error */}
                            </li>
                        ))}

           
                    </ul>
                </div>
            </div>
        </div>
    );
}
